import { render, staticRenderFns } from "./LayoutPropertyDetailsCard.vue?vue&type=template&id=c17c96a2&scoped=true&"
import script from "./LayoutPropertyDetailsCard.vue?vue&type=script&lang=js&"
export * from "./LayoutPropertyDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPropertyDetailsCard.vue?vue&type=style&index=0&id=c17c96a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17c96a2",
  null
  
)

export default component.exports